module.exports = __webpack_public_path__ + "img/sidebar-icon-download-report.8f13236b.svg";